import { ofType } from "redux-observable";
import { merge } from "rxjs";
import { delay, take } from "rxjs/operators";
import { combineChecks } from "../../guards/combineChecks";
import { guard } from "../../guards/guard";
import { pathEmpty } from "../../guards/pathEmpty";
import { TypeActionTutorial } from "../actionTutorial";
import { checkTutorialNextStepConfigExists } from "../checks/checkTutorialNextStepConfigExists";
import { checkTutorialNeedFocusOnBuilding } from "../restore/checks/checkTutorialNeedFocusOnBuilding";
import { checkTutorialOpenQuestMenu } from "../restore/checks/checkTutorialOpenQuestMenu";
import { checkTutorialPurchaseBuilding } from "../restore/checks/checkTutorialPurchaseBuilding";
import { checkTutorialStepIsClickBuyButton } from "../restore/checks/checkTutorialStepIsClickBuyButton";
import { checkTutorialStepIsSelectRecipe } from "../restore/checks/checkTutorialStepIsSelectRecipe";
import { pathFocusOnBuilding } from "../restore/path/pathFocusOnBuilding";
import { pathOpenQuestMenu } from "../restore/path/pathOpenQuestMenu";
import { pathPurchaseBuilding } from "../restore/path/pathPurchaseBuilding";
import { pathSelectBuildingInBase } from "../restore/path/pathSelectBuildingInBase";
import { pathSelectBuildingInBuildingMenu } from "../restore/path/pathSelectBuildingInBuildingMenu";
export var epicTutorialInit = function (action$, state$, deps) {
    var action1$ = action$.pipe(ofType(TypeActionTutorial.Init), guard(state$, deps, pathEmpty)([
        combineChecks([checkTutorialNextStepConfigExists, checkTutorialOpenQuestMenu])(pathOpenQuestMenu),
    ]));
    var action2$ = action$.pipe(ofType(TypeActionTutorial.Init), guard(state$, deps, pathEmpty)([
        combineChecks([checkTutorialNextStepConfigExists, checkTutorialPurchaseBuilding])(pathPurchaseBuilding),
    ]));
    var action3$ = action$.pipe(ofType(TypeActionTutorial.Init), guard(state$, deps, pathEmpty)([
        combineChecks([checkTutorialNextStepConfigExists, checkTutorialStepIsSelectRecipe])(pathSelectBuildingInBase),
    ]));
    var action4$ = action$.pipe(ofType(TypeActionTutorial.Init), delay(200), guard(state$, deps, pathEmpty)([
        combineChecks([checkTutorialNextStepConfigExists, checkTutorialStepIsClickBuyButton])(pathSelectBuildingInBuildingMenu),
    ]));
    var action5$ = action$.pipe(ofType(TypeActionTutorial.Init), take(1), delay(200), guard(state$, deps, pathEmpty)([
        combineChecks([checkTutorialNextStepConfigExists, checkTutorialNeedFocusOnBuilding])(pathFocusOnBuilding),
    ]));
    return merge(action1$, action2$, action3$, action4$, action5$);
};



//////////////////
// WEBPACK FOOTER
// ./src/features/tutorial/epics/epicTutorialInit.ts
// module id = 2467
// module chunks = 3